import {DRAWER} from "./drawer";
import {U, __, short_popup} from "./global";
import {GTM} from "./gtm";
import {USER} from "./user";

export const EXCHANGE = {
    products: [],
    product: {},
    device: {},
    questions: [],
    answers: [],
    products_loaded: false,
    products_loaded_error: '',
    sku: 0,

    reset: function() {
        $(".exchange__container").removeClass('exchange__container-run');

        $(".exchange__questionstitle").empty();
        $(".exchange__questionstext").empty();
        $(".exchange__questionsbuttons").empty();

        $(".exchange__questionsform").addClass('hidden');
        $(".exchange__orderform").addClass('hidden');
        $(".exchange__selectfrom").removeClass('hidden');

        $(".exchange__deviceform").trigger('reset');
        $(".exchange__deviceform [name=vendor]").val('').trigger('change');
        $(".exchange__deviceform [type=submit]").removeClass('active');

        this.hide_price();
        this.product = {};
        this.device = {};
        this.answers = [];
    },

    intersect: function(a, b) {
        return a.filter(Set.prototype.has, new Set(b));
    },

    load_products: function() {
        this.products_loaded = false;
        this.products_loading = true;
        $(".ex__ion").addClass('ex__ion-loading');

        $.ajax({
            type: "POST",
            url: "/aj",
            data: {
                action: 'exchange',
                locale: G.locale_id,
                to: 'products',
            },
            dataType: "json",
            timeout: 10000, // in milliseconds
            success: (data) => {
                this.products = data.products.filter(i => !(i.vendor.toLowerCase()=='apple' || i.vendor.toLowerCase()=='google'));
                this.products_loaded = true;
                this.load_values('vendor');
                $(".exchange__container").removeClass('load-animation');
                this.products_loading = false;
                $(".ex__ion").removeClass('ex__ion-loading');
            },
            error: (request, status, err) => {
                this.products_loaded_error = 'Не вдалось завантажити список товарів. Оновіть сторінку.';
                $(".js-ex__ion-error").removeClass('hidden').html(this.products_loaded_error);
                this.products_loading = false;
                $(".ex__ion").removeClass('ex__ion-loading');
            }
        });
    },

    get_filters: function() {
        let arr = {};
        let form = $('.exchange__deviceform');

        if (form.find('[name=vendor]').val()) {
            arr['vendor'] = form.find('[name=vendor]').val();

            if (form.find('[name=category]').val()) {
                arr['category'] = form.find('[name=category]').val();

                if (form.find('[name=subcategory]').val()) {
                    arr['subcategory'] = form.find('[name=subcategory]').val();

                    if (form.find('[name=storage]').val()) {
                        arr['storage'] = form.find('[name=storage]').val();

                        if (form.find('[name=color]').val()) {
                            arr['color'] = form.find('[name=color]').val();
                        }
                    }
                }
            }
        }

        return arr;
    },

    load_values: function(field) {
        let vendors = this.products;
        let filters = this.get_filters();

        if (filters, Object.keys(filters).length) {
            Object.entries(filters).forEach(([key, value]) => {
                vendors = vendors.filter((v, i) => v[key]==value);
            });
        }

        vendors = vendors.map( el => el[field] );
        vendors = vendors.filter((v, i, a) => a.indexOf(v) === i);
        vendors.forEach((item) => {
            $(".exchange__deviceform select[name=" + field + "]").append('<option value="' + item + '">' + item + '</option>');
        });
    },

    fill_values: function() {

    },

    apply_changes: function(element) {
        let form = $('.exchange__deviceform');
        $(".js-exchange__deviceformsubmit").removeClass('success').addClass("cancel").parent().removeClass('hidden');
        EX.submit_button(false);

        // reset changes
        let fields = ['vendor', 'category', 'subcategory', 'storage', 'color'];
        let clean = false;

        fields.forEach((e) => {
            if (clean) {
                form.find('[name=' + e + '] option').not("[value='']").remove();
                form.find('[name=' + e + ']').trigger('reset');
            }

            if (element.attr('name')==e)
                clean = true;
        });

        if (form.find('[name=vendor]').val()) {
            form.find('[name=category]').parents('.form-item').removeClass('form-item-disabled');

            if (form.find('[name=category] option').length < 2) {
                this.load_values('category');
            }
        }

        if (form.find('[name=category]').val()) {
            form.find('[name=subcategory]').parents('.form-item').removeClass('form-item-disabled');

            if (form.find('[name=subcategory] option').length < 2) {
                this.load_values('subcategory');
            }
        }

        if (form.find('[name=subcategory]').val()) {
            form.find('[name=storage]').parents('.form-item').removeClass('form-item-disabled');

            if (form.find('[name=storage] option').length < 2) {
                this.load_values('storage');
            }
        }

        if (form.find('[name=storage]').val()) {
            form.find('[name=color]').parents('.form-item').removeClass('form-item-disabled');

            if (form.find('[name=color] option').length < 2) {
                this.load_values('color');
            }
        }

        if (element.attr('name')=='color') {
            // lookup device
            let devices = this.products;
            let filters = this.get_filters();

            if (filters, Object.keys(filters).length) {
                Object.entries(filters).forEach(([key, value]) => {
                    devices = devices.filter((v, i) => v[key]==value);
                });
            }

            if (devices.length > 0) {
                this.product = devices[0];
                this.add_device(this.product.productId);
                EX.show_image();
            }
        } else {
            this.hide_price();
        }

        this.fill_values();
    },

    hide_price: function() {
        $(".exchange__selected").addClass('hidden');
        $(".exchange__selectedtitle").empty();
        $(".exchange__selectedtext").empty();
        $(".exchange__selectedprice").empty();

    },

    add_device: function(value) {
        $.ajax({
            type: "POST",
            url: "/aj",
            data: {
                action: 'exchange',
                to: 'adddevice',
                locale: G.locale_id,
                device: value
            },
            dataType: "json",
            timeout: 10000, // in milliseconds
            success: (device) => {
                this.device = device;
                $(".exchange__selected").removeClass('hidden');
                $(".exchange__deviceform .js-exchange__deviceformsubmit").addClass('success').removeClass("cancel");
                $(".exchange__selectedtitle").html(this.product.description);
                $(".exchange__selectedprice").html(this.device.price + ' грн');

                EX.device = {
                    sku: 0,
                    price: parseInt(this.device.price),
                    image: '',
                    title: this.product.description,
                }

                EX.show_sku();
            },
            error: function(request, status, err) {

            }
        });
    },

    run_questions: function() {
        $(".js-exchange__deviceformsubmit").parent().addClass('hidden');
        EX.answers = [];

        $.ajax({
            type: "POST",
            url: "/aj",
            data: {
                action: 'exchange',
                to: 'questions',
                locale: G.locale_id,
                deviceId: this.device.deviceId
            },
            dataType: "json",
            timeout: 10000, // in milliseconds
            success: (question) => {
                const container = $('.js-ex__questionion');
                container.removeClass('hidden');

                // $(".exchange__questionsform").removeClass('hidden');
                // $(".exchange__selectfrom").addClass('hidden');
                // $(".exchange__container").addClass('exchange__container-run');
                this.questions.push(question);
                this.build_question(question);
                // $("html, body").stop().animate({scrollTop: $(".exchange__container").offset().top - 80}, '100', 'swing');
            },
            error: function(request, status, err) {

            }
        });
    },

    build_question: function(question) {
        this.question = question;
        $(".exchange__questionstitle").empty().html(question.question);
        $(".exchange__questionstext").empty();

        $(".js-ex__questionion").data('id', question.questionId);

        if (typeof question.description !== "undefined")
            $(".exchange__questionstext").html(question.description);

        question.options = typeof question.options === "undefined" ? [] : question.options;

        if (question.options.length > 0) {
            $(".exchange__questionstext").append('<div class="exchange__check"></div>');
            question.options.forEach(e => {
                $(".exchange__check").append('<div class="exchange__checkitem">\n' +
                    '        <label class="exchange__checkitemtitle">\n' +
                    '            <input type="checkbox" name="' + e.cid + '" value="1" /><span>' + e.cname + '</span>\n' +
                    '        </label>\n' +
                    '        <div class="exchange__checkitemdesc">\n' + e.description + '</div>\n' +
                    '    </div>');
            });
        }

        $(".exchange__questionsbuttons").empty();
        if (question.answerType=='YN') {
            $(".exchange__questionsbuttons").html(
                '<button type="button" class="btn btn-minwidth100 exchange__answerbtn" data-val="Y">' + __('Так') + '</button>\n' +
                '<button type="button" class="btn btn-minwidth100 exchange__answerbtn" data-val="N">' + __('Ні') + '</button>'
            );
        }

        if (question.answerType=='MULTISELECT' || question.answerType=='SINGLESELECT') {
            $(".exchange__questionsbuttons").html(
                '<button type="button" class="btn btn-minwidth100 exchange__answerbtn" data-val="">' + __('Далі') + '</button>\n'
            );
        }

        if (this.questions.length > 1) {
            $(".exchange__questionsbuttons").prepend(
                '<button class="btn ex__questionsubmit exchange__answerbtnback">Назад</button>'
            );
        }
    },

    defects: function() {
        return this.answers;
    },

    question_back: function() {
        const showed_id = $(".js-ex__questionion").data('id');

        this.questions = this.questions.filter(i => i.questionId!=showed_id);
        this.answers = this.answers.filter(i => i.id!=showed_id);
        EX.answers = EX.answers.filter(i => i.id!=showed_id);

        console.log('questions', this.questions);

        if (this.questions.length > 0) {
            const question = this.questions[this.questions.length - 1];
            this.answers = this.answers.filter(i => i.id!=question.questionId);
            EX.answers = EX.answers.filter(i => i.id!=question.questionId);
            this.build_question(question);
        } else {
            this.run_questions();
        }
    },

    send_answer: function(YN) {

        let answer = [];
        let c = [];

        if ($(".exchange__checkitem").length > 0)
            $.each($(".exchange__checkitem"), function(i, item){
                item = $(item);

                if (item.find('input').prop('checked')) {
                    c.push(item.find('input').attr('name'));
                    answer.push(item.find('label span').text());
                }
            });
        else
            answer.push(YN=='Y' ? 'Так': 'Ні');

        this.answers.push({
            id: $(".js-ex__questionion").data('id'),
            question: $(".exchange__questionstitle").text(),
            answer: answer.join(', '),
            c: c.join(','),
            YN
        });

        EX.answers.push({
            id: $(".js-ex__questionion").data('id'),
            question: $(".exchange__questionstitle").text(),
            answers: answer.map(item => {
                return {
                    title: item,
                    percent: 0
                };
            })
        });

        this.send_answer_request(this.question.questionId, YN, c.join(','));
    },

    send_answer_request: function(questionId, YN, c) {
        $.ajax({
            type: "POST",
            url: "/aj",
            data: {
                locale: G.locale_id,
                action: 'exchange',
                to: 'answers',
                deviceId: this.device.deviceId,
                questionId: questionId,
                YN: YN,
                c: c,
            },
            dataType: "json",
            timeout: 10000, // in milliseconds
            success: (question) => {
                let is_last = typeof question.question === "undefined" ? true : false;
                if (is_last) {
                    $(".exchange__questionsform").addClass('hidden');
                    $(".exchange__orderform").removeClass('hidden');
                    this.device = question.device;
                    EX.device.calculated_price = question.device.price;
                    $(".ex__rightinner").removeClass('hidden');
                    $(".ex__rightblocks").addClass('hidden');
                    EX.submit_button(true);
                    EX.show_sku(true)
                    EX.write_storage();
                } else {
                    this.questions.push(question);
                    this.build_question(question);
                }
            },
            error: function(request, status, err) {

            }
        });
    },

    calculate_slr_price: function() {
        let price_origin = parseInt($(".product-list li.active .js-exchange__selectmodel").data('price'));
        let percentage_sum = 0;

        if ($(".js-exchange__selectdefect.exchange__defect").length > 0)
            $.each($(".js-exchange__selectdefect.exchange__defect"), (i, item) => {
                 item = $(item);
                 if (item.hasClass('active'))
                     percentage_sum = percentage_sum + parseInt(item.find('input').data('price'));
            });

        if (percentage_sum > 0)
            price_origin = parseInt((price_origin * (100 - percentage_sum)) / 100);

        this.setPrice(price_origin);
        this.check_submit();

        return price_origin;
    },

    setPrice: function(price) {
        $(".exchange-levels .loop__price").html('<small>' + __('Повертаємо до') + '</small> ' + price + '&nbsp;грн').data('price', price);
    },

    check_submit: function() {
        $(".process_button").addClass('success').removeClass("cancel");
    },

    submitslrform: function() {
        let data = {
            action: 'slr',
            to: 'exchange',
            defects: [],
            model: $(".product-list li.active .js-exchange__selectmodel").text(),
            origin_price: $(".product-list li.active .js-exchange__selectmodel").data('price'),
            price: this.calculate_slr_price()
        };

        if ($(".js-exchange__selectdefect.exchange__defect").length > 0)
            $.each($(".js-exchange__selectdefect.exchange__defect"), (i, item) => {
                item = $(item);
                if (item.hasClass('active'))
                    data.defects.push({
                        title: item.text(),
                        percentage: item.find('input').data('price')
                    });
            });

        $.post(
            '/aj',
            data,
            (data) => {
                if (U.isMobile()) {
                    DRAWER.init('workdrawer-exchangeslr-thx', {action: 'popup', to: 'exchangeslrthx'});
                } else {
                    DRAWER.destroy();
                    short_popup(data.html, 'workdrawer-exchangeslr-thx');
                }
            },
            'json'
        );
    }
};

export const EX = {

    answers: [],
    device: {},

    init_from_localStorage: async function() {
        if (localStorage.getItem('exchange_selected')) {
            const parsed = JSON.parse(localStorage.getItem('exchange_selected'));

            this.answers = parsed.answers ?? [];
            this.device = parsed.device ?? {};

            if (this.device) {
                this.show_sku(true);
                this.show_image();
                this.submit_button(true);

                $(".ex__changedevice").removeClass('hidden');

                // steps
                if (0 && parsed.devicetype) {
                    const promises = [];

                    promises.push(async () => {
                        return await EX.load_model(parsed.devicetype)
                    });

                    $.each(parsed.categories, (i, item) => {
                        if (i == 0) {
                            promises.push(async () => {
                                return await EX.load_step(1).then(() => {
                                    $(".js-ex__selectmodel").val(item).trigger('change');
                                })
                            });
                        } else {
                            promises.push(async () => {
                                const btn = $(`.ex__step[data-id=${i}] select`);
                                btn.val(item).trigger('change');
                                console.log(`-----${i}---${item}` ,btn.val());
                                return await EX.select_value(btn);
                            });
                        }
                    });

                    console.log($(`.ex__step select`).val());

                    promises
                        .reduce((p, fn) => p.then(fn), Promise.resolve())
                        .then(() => console.log("Готово"));
                }
            }
        } else {
            $(".js-ex__devicetype[data-id=1]").trigger('click');
        }

        if (localStorage.getItem('exchange_openauth')) {
            $(".js-ex__sendbutton").trigger('click');
            localStorage.removeItem('exchange_openauth')
        }
    },

    send_device: function(params = {}) {
        console.log('send_device', params);
        const data = {
            repurchase: 0,
            to: 'senddevice',
            sku: this.device ? this.device.sku : '',
            calculated_price: this.calculate_device_price(),
            title: this.device ? this.device.title : '',
            price: this.device ? this.device.price : '',
            answers: JSON.stringify(this.answers),
            anotherdevice_description: $("[name=anotherdevice_description]").length > 0 ? $("[name=anotherdevice_description]").val() : '',
            ...params,
        };

        if (data.repurchase == 1) {
            data.calculated_price = this.calculate_device_repurchase_price();
        }

        const btn = $(".js-ex__sendbutton");

        if (btn.hasClass('loading')) {
            return;
        }

        btn.addClass('loading');

        this.postData(
            data
        )
            .then(data => {
                if (data.success) {
                    if (U.isMobile()) {
                        DRAWER.init('workdrawer-full workdrawer-exchange_thx', {action: 'exchange', to: 'thx'});
                    } else {
                        DRAWER.destroy();
                        short_popup(data.html);
                    }
                    this.clear_selected_device();
                    this.clear_image();
                    localStorage.removeItem('exchange_openauth');
                } else {
                    USER.openFillPhonePopup();
                }
            })
            .finally(() => {
                btn.removeClass('loading');
            });
    },

    postData: async function (data = {}, url = '/aj', timeout = 10000) {

        data.action ??= 'exchange';

        AbortSignal.timeout ??= function timeout(ms) {
            const ctrl = new AbortController()
            setTimeout(() => ctrl.abort(), ms)
            return ctrl.signal
        }

        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            signal: AbortSignal.timeout(timeout),
            body: new URLSearchParams(data)
        });
        return response.json(); // parses JSON response into native JavaScript objects
    },

    clear_selected_device: function() {
        console.log('clear_selected_device');
        $(".js-ex_changedevice").addClass('hidden');
        $(".js-ex__selectedsku").empty();

        $(".js-ex__sendcontainer-norepurchase, .js-ex__sendcontainer-repurchase").addClass('hidden');

        this.device = {};
        this.answers = [];
        this.submit_button(false);
        this.write_storage(true);
    },

    clear_image: function() {
        $(".js-ex__modelimage").empty().removeClass('ex__modelimage-imageless');
        $(".ex__right .ex__rightinner").addClass('hidden');
        $(".ex__right .ex__rightblocks").removeClass('hidden');
    },

    load_step: function(step_number, params = {}) {
        params.step = step_number;
        params.model_id = this.getModelId();

        return new Promise((resolve, reject) => {
            if (this.getModelId()=='another') {
                console.log(`manager_logged ${G.manager_logged}`);

                $('.js-ex__steps').empty();
                this.clear_selected_device();
                this.clear_image();
                $('.js-ex__question').empty();
                //
                // EX.clear_selected_device();
                // $('.js-ex__question').empty();
                $(".js-ex__steps").empty().append(`
                <textarea name="anotherdevice_description" rows="4" placeholder="Опишіть ваш пристрій, та недоліки, присутні на ньому"></textarea>
                
                <div class="js-ex__sendcontainer">
                    <button class="btn js-${G.manager_logged ? 'slr-' : ''}ex__sendbutton" type="button">Відправити заявку</button>
                </div>                
            `);

                $(".js-ex__steps .js-ex__sendcontainer").removeClass('hidden');

                resolve();
            } else {
                this.postData({
                    to: 'step',
                    ...params
                }).then(data => {
                    if (params.step == 1) {
                        this.clear_selected_device();

                        const steps_container = $(".js-ex__steps");
                        steps_container.empty();

                        data.steps.forEach(step => {
                            const step_container = $(`<div class="ex__step" data-id="${step.number}">
                            <select class="js-ex__value" data-placeholder="${step.title}" disabled><option value="">${step.title}</option></select>
                        </div>`);
                            steps_container.append(step_container);
                        });

                        steps_container.find('select').select2({
                            minimumResultsForSearch: -1
                        });

                        this.show_image(data.image);
                    }

                    if (this.getModelSteps() > 0) {
                        const __step_container = $(`.ex__step[data-id=${params.step}]`);

                        data.values.map(item => {
                            const option = $("<option/>", {
                                value: item.id,
                                text: item.title
                            });

                            option.data('sku', item.sku);

                            __step_container.find('select').append(option);
                        });

                        __step_container.find('select').prop('disabled', false);

                        // block future steps
                        if (params.step < 3) {
                            for (let i = (params.step + 1); i <= 3; i++) {
                                const step_container = $(`.ex__step[data-id=${i}]`);
                                step_container.find('option').not(`[value='']`).remove();
                                step_container.find('select').prop('disabled', true);
                            }
                        }
                    } else {
                        this.load_questions(this.getDeviceType());
                        this.load_sku(this.getModelSku()).then(() => {
                            GTM.fireStatistick('statistick', 'click', 'Tradein Клієнт вибрав пристрій на обмін', '');
                            // this.show_results();
                        })
                    }
                }).finally(() => {
                    resolve();
                });
            }
        });
    },

    load_model: function(device_type) {

        $(".js-ex__devicetype").removeClass('selected active');
        $(`.js-ex__devicetype[data-id=${device_type}]`).addClass('selected active');

        const container = $('.js-ex__models');
        container.empty();
        $('.js-ex__steps').empty();
        this.clear_selected_device();
        this.clear_image();
        $('.js-ex__question').empty();

        if (device_type=='another') {
            return new Promise((resolve, reject) => {
                $(".ex__our").addClass('hidden');
                $(".ex__ion").removeClass('hidden');
                $(".ex__ion select").select2({});

                if (!EXCHANGE.products_loaded) {
                    if (EXCHANGE.products_loaded_error != '') {
                        $(".js-ex__ion-error").removeClass('hidden').html(EXCHANGE.products_loaded_error);
                    }
                } else {
                    $(".js-ex__ion-error").addClass('hidden');
                }

                resolve();
            })
        } else {
            $(".ex__our").removeClass('hidden');
            $(".ex__ion").addClass('hidden');

            return this.postData({
                to: 'models',
                device_type
            }).then(data => {
                container.empty();

                container.append(`
                    <div class="form-item clearfix">
                    <select class="js-ex__selectmodel" data-placeholder="Модель пристрою">
                        <option value="">Модель пристрою</option>
                    </select>
                    </div>
                `);

                data.models.map(item => {
                    const option = $("<option/>", {
                        value: item.id,
                        text: item.title
                    });

                    option.data('steps', item.steps);
                    option.data('sku', item.sku);
                    container.find('select').append(option);
                });

                // add інший
                const option = $("<option/>", {
                    value: 'another',
                    text: 'Інша модель'
                });

                option.data('steps', 0);
                option.data('sku', 0);
                container.find('select').append(option);

                container.find('select').select2({
                    minimumResultsForSearch: -1
                });
            });
        }
    },

    getDeviceType: function() {
        return $(".js-ex__devicetype.selected").data('id');
    },

    getModel: function() {
        return $(".js-ex__selectmodel option:selected");
    },

    getModelId: function() {
        return this.getModel().val();
    },

    getModelSku: function() {
        return this.getModel().data('sku');
    },

    getModelSteps: function() {
        return parseInt(this.getModel().data('steps'));
    },

    load_questions: function(device_type) {
        this.answers = [];
        this.postData({
            to: 'question',
            device_type
        }).then(data => {
            if (data.question) {
                this.build_question(data.question);
            } else {
                this.show_results();
            }
        });
    },

    build_question: function(question) {
        const container = $('.js-ex__question');
        container.empty();

        container.html(`
            <div class="ex__question" data-id="${question.id}">
                <h3>${question.title}</h3>
                ${question.description!='' ? `<i>${question.description}</i>` : ``}
                
                <div class="ex__questionanswers">
                    ${question.answers.map(answer => {
                        return `
                        <label class="radiobox">
                            <input type="${question.type}" name="answer" value="${answer.id}" />
                            <div class="checkbox__title" data-percent="${answer.percent}">${answer.title}</div>
                            <small><i>${answer.description}</i></small>
                        </label>`;
                    }).join('')}
                </div>
                
                <div class="clearfix"></div>
                <div class="alert alert-danger hidden">Дайте відповідь на питання</div>
                <div class="clearfix"></div>
                
                <center>
                    ${this.answers.length > 0 ? `<button class="btn ex__questionsubmit js-ex__questionback">Назад</button>` : ''}
                    <button class="btn ex__questionsubmit js-ex__questionsubmit">Далі</button>
                </center>
            </div>
        `);
    },

    show_results: function() {
        $(".js-ex__selectedprice").html(`${this.calculate_device_price()} грн`);
        $(".ex__rightinner").removeClass('hidden');
        $(".ex__rightblocks").addClass('hidden');

        console.log('show_results');

        this.write_storage();
        this.show_sku(true);
        this.submit_button(true);
    },

    question_back: function()
    {
        const container = $('.js-ex__question');
        const showed_id = $(".ex__question").data('id');

        this.answers = this.answers.filter(i => i.id!=showed_id);
        let question_id = 0;

        if (this.answers.length > 0) {
            const answer = this.answers.pop();

            if (this.answers.length > 0) {
                const ans = this.answers[this.answers.length - 1]
                question_id = ans.id;
            }
        }

        this.go_question(question_id)
    },

    go_question: function(question_id)
    {
        console.log('go question', question_id);
        const container = $('.js-ex__question');
        this.postData({
            to: 'question',
            device_type: this.getDeviceType(),
            prev: question_id
        }).then(data => {
            if (data.question) {
                this.build_question(data.question);
            } else {
                container.empty();
                this.show_results();
            }
        });
    },

    submit_question: function()
    {
        const container = $('.js-ex__question');
        const question_id = container.find('.ex__question').data('id');
        const len = container.find('.ex__questionanswers input:checked').length;
        container.find('.alert').addClass('hidden');

        if (len > 0) {
            const answers = [];

            $.each(container.find('.ex__questionanswers input:checked'), (i, item) => {
                item = $(item);
                answers.push({
                    title: item.parent().find('.checkbox__title').text(),
                    percent: item.parent().find('.checkbox__title').data('percent'),
                });
            });

            this.answers.push({
                id: question_id,
                question: container.find('h3').text(),
                answers
            });

            console.log(this.answers);

            this.go_question(question_id);
        } else {
            container.find('.alert').removeClass('hidden');
        }
    },

    write_storage: function(clear = false) {
        if (clear) {
            localStorage.removeItem('exchange_selected');
        } else {
            const categories = [];

            categories.push($(".js-ex__selectmodel").val());
            $.each($(".js-ex__steps .ex__step select"), (i, item) => {
                categories.push($(item).val());
            });

            const write = {
                device: this.device,
                answers: this.answers,
                categories: categories,
                devicetype: $(".js-ex__devicetype.active").data('id')
            };

            // console.log('write_storage', write);
            localStorage.setItem('exchange_selected', JSON.stringify(write));
        }
    },

    submit_button: function(show) {
        if (show) {
            $(".js-ex__sendcontainer").removeClass('hidden');
        } else {
            $(".js-ex__sendcontainer").addClass('hidden');
        }
    },

    select_value: function(select) {
        const containner = select.parents('.ex__step');
        const current_step_id = parseInt(containner.data('id'));
        const model_steps = parseInt($(".js-ex__selectmodel option:selected").data('steps'));
        containner.find('.js-ex__value').removeClass('selected active');
        this.clear_selected_device();

        console.log('model_steps', model_steps);

        if (model_steps == current_step_id) {
            return new Promise((resolve, reject) => {
                this.load_sku(select.find('option:selected').data('sku'))
                this.load_questions(this.getDeviceType());
                resolve();
            });
        } else {
            const params = {};
            params.selected = {};

            for (let i = 1; i <= current_step_id; i++)
                params.selected[i] = $(`.ex__step[data-id=${i}] option:selected`).val();

            params.selected = JSON.stringify(params.selected);
            return this.load_step(current_step_id + 1, params);
        }
    },

    load_sku: function(sku) {
        return this.postData({
            to: 'skuinfo',
            sku
        }).then(data => {
            this.device = data.device;
            this.show_sku();
            this.write_storage();
        });
    },

    show_image: function(image = '') {
        let path = image!='' ? image : this.device?.image;

        if (path) {
            $(".ex__modelimage").removeClass('ex__modelimage-imageless');
            $(".ex__right").addClass('ex__right-selected');
            $(".js-ex__modelimage").empty().html(`<img src="${path}" />`);

            $(".ex__right .ex__rightinner").removeClass('hidden');
            $(".ex__right .ex__rightblocks").addClass('hidden');
        } else {
            $(".ex__modelimage").addClass('ex__modelimage-imageless');

            $(".ex__right .ex__rightinner").addClass('hidden');
            $(".ex__right .ex__rightblocks").removeClass('hidden');
        }
    },

    show_sku: function(max = false) {
        console.log('device', this.device);

        const device_price = this.calculate_device_price();

        if (this.device?.repurchase_price > 0) {
            const repurchase_price = this.calculate_device_repurchase_price();

            $(".js-ex__sendcontainer-norepurchase").addClass('hidden');
            $(".js-ex__sendcontainer-repurchase").removeClass('hidden');

            $(".js-ex__btn strong").html(`${device_price}&nbsp;₴`);
            $(".js-ex__btn-white strong").html(`${repurchase_price}&nbsp;₴`);
        } else {
            $(".js-ex__sendcontainer-norepurchase").removeClass('hidden');
            $(".js-ex__sendcontainer-repurchase").addClass('hidden');

            $(".js-ex__selectedsku").html(`
                <div class="exchange__selected">
                    <div class="exchange__selectedl">
                        <div class="exchange__selectedleft">
                            <div class="exchange__selectedtitle">${this.device?.title}</div>
                            <div class="exchange__selectedsmall">* ${max ? `Максимальна ціна викупу за ваш пристрій` : `Максимальна ціна викупу`}</div>
                        </div>
                        <div class="exchange__selectedprice js-ex__selectedprice">${device_price}&nbsp;грн</div>
                    </div>
                </div>
            `).removeClass('hidden');
        }

    },

    calculate_device_price: function() {
        let percent = 0;

        this.answers.map(answer => {
            answer.answers.map(_answer => {
                percent += _answer.percent;
            })
        });

        percent = percent > 85 ? 85 : percent;

        return this.device?.calculated_price ?
            this.device.calculated_price :
            (this.device?.price ? parseInt(this.device.price * (100 - percent) / 100) : '')
        ;
    },

    calculate_device_repurchase_price: function() {
        const price = this.calculate_device_price();
        return parseInt(price * (100 - this.device.repurchase_percent) / 100)
    }
}

export function init_EXCHANGE_events() {
    console.info('exchange loaded');
    $(document).ready(function () {

        if (document.location.pathname.substring(0, 9)=='/exchange') {
            EXCHANGE.load_products();
        }

        $(".exchange__container select").select2({
            minimumResultsForSearch: -1
        });

        jQuery("body").on('change', '.exchange__deviceform select', function (e) {
            EXCHANGE.apply_changes($(this));
        });

        jQuery("body").on('click', '.js-exchange__deviceformsubmit', function (e) {
            e.preventDefault();

            if (EXCHANGE.device) {
                $(".exchange__container-solo").removeClass('exchange__container-solo');
                EXCHANGE.run_questions();
            }
        });

        jQuery("body").on('click', '.exchange__answerbtn', function (e) {
            e.preventDefault();
            EXCHANGE.send_answer($(this).data('val'));
        });

        jQuery("body").on('click', '.exchange__answerbtnback', function (e) {
            e.preventDefault();
            EXCHANGE.question_back();
        });

        $("body").on('submit', '.exchange__orderform', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let form = $(this);

            let data = {
                locale: G.locale_id,
                action: 'exchange',
                to: 'submit',

                name: form.find('[name=name]').val(),
                phone: form.find('[name=phone]').val(),
                email: form.find('[name=email]').val(),

                product: EXCHANGE.product.description + ', ' + EXCHANGE.product.color + ', ' + EXCHANGE.product.storage,
                price: EXCHANGE.device.price,
                gradeName: EXCHANGE.device.gradeName,

                defects: EXCHANGE.defects()
            };

            // validation
            let errors = 0;

            if (data.phone.replace(/\D/g, '').length == 10) {
                form.find('[name=phone]').parent().parent().find('.error').addClass('hidden');
            } else {
                form.find('[name=phone]').parent().parent().find('.error').removeClass('hidden');
                errors++;
            }

            if (errors == 0)
                $.post('/aj', data, function (data) {
                    if (data.success) {
                        if (U.isMobile()) {
                            DRAWER.init('workdrawer-full workdrawer-exchange_thx', {action: 'exchange', to: 'thx'});
                        } else {
                            DRAWER.destroy();
                            short_popup(data.html);
                        }

                        EXCHANGE.reset();
                    } else {
                        // error
                    }
                }, 'json');
            else
                $(".exchange__orderform .alert").removeClass('hidden');

            return false;
        });

        $("body").on('click', '.js-exchange__selectmodel', function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.parent().parent().find('li').removeClass('active');
            btn.parent().addClass('active');
            EXCHANGE.sku = btn.data('sku');
            $(".exchange-levels .loop__title").html(btn.text());
            $(".exchange-levels .loop__image").html('<img src="' + btn.data('image') + '" />');
            EXCHANGE.setPrice(btn.data('price'));
            $(".exchange-levels .loop").removeClass('hidden');
            return false;
        });

        $("body").on('click', '.js-exchange__gotodefects', function (e) {
            e.preventDefault();
            let btn = $(this);
            $(".exchange-levels >div").removeClass('active');
            $(".exchange-levels .three").addClass('active');
            return false;
        });

        $("body").on('click', '.js-exchange__selectdefect', function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.toggleClass('active');
            let checked = btn.find('input').prop('checked');
            btn.find('input').prop('checked', checked ? 0 : 1);

            EXCHANGE.calculate_slr_price();
            return false;
        });

        $("body").on('click', '.js-exchange__submitslrform', function (e) {
            e.preventDefault();
            EXCHANGE.submitslrform();
        });

        $("body").on('click', '.workdrawer-exchangeslr-thx .close', function (e) {
            e.preventDefault();
            e.stopPropagation();
            document.location.reload();
        });

        U.mask_inputs();

        // new
        $("body").on('click', '.js-ex__devicetype', function (e) {
            e.preventDefault();
            const btn = $(this);

            EX.load_model($(this).data('id'));
        });

        $("body").on('change', '.js-ex__selectmodel', function (e) {
            e.preventDefault();
            const btn = $(this);
            // $(".js-ex__model").removeClass('selected');
            EX.load_step(1);
        });

        $("body").on('change', '.js-ex__value', function (e) {
            e.preventDefault();
            const btn = $(this);
            EX.select_value(btn);
        });

        $("body").on('click', '.js-ex__questionsubmit', function (e) {
            e.preventDefault();
            const btn = $(this);
            EX.submit_question(btn);
        });

        $("body").on('click', '.js-ex__questionback', function (e) {
            e.preventDefault();
            EX.question_back();
        });

        $("body").on('click', '.js-ex__sendbutton, .js-ex__sendbutton-repurchase', function (e) {
            e.preventDefault();
            let logged = (G.client !== undefined) || G.manager_logged;
            const repurchase = $(this).hasClass('js-ex__sendbutton-repurchase') ? 1 : 0;

            if ($(".header__login").length == 0 || logged) {
                EX.send_device({repurchase});
                GTM.fireStatistick('statistick', 'click', 'Tradein Клієнт відправив запит на обмін', '');
            } else {
                localStorage.setItem('exchange_openauth', '1');
                $(".header__login").trigger('click')
            }
        });

        GTM.fireStatistick('statistick', 'click', 'Tradein Клієнт зайшов на сторінку', '');
        EX.init_from_localStorage();

        $("body").on('click', '.js-ex_changedevice', function (e) {
            e.preventDefault();
            $(".js-ex__devicetype[data-id=1]").trigger('click');
        });



    });
}

init_EXCHANGE_events();